/**
 * @file index.tsx
 * @module app/modules/custom-notification
 * @description Defines routing and page metadata for the Custom Notification module.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_admin/layout/core';
import CustomNotification from './custom-notification';
const customNotificationBreadCrumbs: Array<PageLink> = [
  {
    title: 'Custom Notification',
    path: '/custom-notification',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const index = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="*"
          element={<Navigate to="/error/404" />}
        />
        {/* <Route index element={<Navigate to="/contact-inquiries" />} /> */}
        <Route
          index
          element={
            <>
              <PageTitle>
                Custom Notification
              </PageTitle>
              <CustomNotification />
            </>
          }
        />
      </Route>
    </Routes>
  );
};
export default index;
